import { FileTypes } from "@/enums";
import { selectFilterHelper } from "@/helpers";
import { Form, Input, Select } from "antd";
import { useIntl } from "react-intl";
import { FormFieldContainer } from "./styled";

export const AttachmentFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="placeholder"
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="requiredValidationText"
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="allowedFileTypes"
        label={intl.formatMessage({ id: "newFormField.allowedFileTypes" })}
      >
        <Select mode="multiple" filterOption={selectFilterHelper}>
          {Object.keys(FileTypes).map((key) => (
            <Select.Option value={key} key={key}>
              {intl.formatMessage({
                id: `enum.fileType.${key}`,
                defaultMessage: key,
              })}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </FormFieldContainer>
  );
};
